import React, { useEffect } from "react";
import ApiServices from "../../services/apiServices";
import storage from "../../services/storage";
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import cookie from "react-cookies";

export default function Auth() {
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (params?.token?.includes("acesso-externo")) {
      storage.del("TOKEN");
      storage.del("USUARIO");
    }
    var url = window.location.href;
    var token = "";
    var userId = "";
    if (url.indexOf("?token") > -1) {
      userId = url.split("&userId=")[1];
      token = url.split("&userId=")[0];
      token = token.substring(token.indexOf("?token="), token.length);
      token = token.replace("?token=", "");
      storage.set("TOKEN", token);
    }

    // ApiServices.apiLoginBase("login/external", token)
    //   .then((res) => {
    //     storage.set("TOKEN", res.data.loginResponse.token);
    //     storage.set("USUARIO", res.data);
    //     if (res.data.loginResponse.token) {
    //       navigate("/home");
    //     }
    //   })
    //   .catch((error) => {
    //     navigate("/deslogado");
    //     console.error("error:", error);
    //   })
    //   .finally();

    if (userId) {
      usuarioEspelho();
    } else {
      // MARCELLO SPIRONELLI
      // MARCELLO SPIRONELLI
      // MARCELLO SPIRONELLI
      // token =
      // "jsnnapkwhMw8clFUYWN/r6LTinQrxwpLuhLaMnsyodIwQaxh4gp9gMB6ywqdD/xklT/JIPc3ursqvFO7cvCbHBUnTHKSKckF2aKx9hG3MjQ7yZaug7f8xWk3VMuKel4pXGvXf9s/PhSxvFmWSX7kj8y2XzwjtvGRCCWmYH1fH+mL4FOhcyP547zRrWziO9IMKeDFA01oQNiIDz3EdvUJljey/Bym3bsyABGsLZXcqnxrvOIgWhk0AtoAdBLvbSZKuNhVTrgIsYKQiqzOnEFAHLZC+MgNfSe+7ui5qI9i6NRs6HcDYRb/WRoBQjz/Bkz7Ni9pMJLGjYV2BX5aIDLPm822k24Rhbe2VYI4T6tpQ71VCcAHgyHgAj4ySE+49/ElrldMElASOn4SBzFMS48Nq4d2gGIrPPAHqV3JfsmUSRGHkCqXlJ3VNL9kCwW7ew2L67iOL/oYDS8tgVjQD+wweQ==";
      token = cookie.load("token");
      if (typeof token === "string" && token.trim() !== "") {
        usuarioExterno();
      } else {
        navigate("/deslogado");
      }
    }

    async function usuarioEspelho() {
      try {
        let response = await ApiServices.apiPostTokenBearer("login/espelho", {
          userId: userId,
        });

        var usuario = {
          codiCli: response.data.profile.codiCli,
          loginResponse: response.data,
          isAmigoLeo: false,
        };

        storage.set("TOKEN", response.data.token);
        storage.set("USUARIO", usuario);
      } catch (err) {
        console.error("err", err);
      } finally {
        if (storage.get("TOKEN") !== null) {
          navigate("/home");
        } else {
          navigate("/deslogado");
        }
      }
    }

    async function usuarioExterno() {
      storage.del("TOKEN");
      storage.del("USUARIO");

      try {
        if (typeof token !== "string" || token.trim() === "") {
          navigate("/deslogado");
          return;
        }

        let response = await ApiServices.apiLoginBase("login/external", token);

        storage.set("TOKEN", response.data.loginResponse.token);
        storage.set("USUARIO", response.data);
        userId = response.data.loginResponse.profile.userId;
      } catch (err) {
        console.error("err", err);
      } finally {
        if (storage.get("TOKEN") !== null) {
          navigate("/home");
        } else {
          navigate("/deslogado");
        }
      }
    }
  }, []);

  return <></>;
}
